<div *ngIf="error" class="error">
    {{ error }}
</div>
<div *ngIf="success" class="success">
  {{ success }}
</div>
